// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.105.2/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.105.2/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CountryFlag-module__flag__LEnOR {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 15px;
  border-radius: var(--mantine-radius-xs);
  overflow: hidden;
  flex-shrink: 0;
}

.CountryFlag-module__sprite__pVzv_ {
  display: block;
}

.CountryFlag-module__sm__IcjdD {
  width: 18px;
  height: 13px;
}

.CountryFlag-module__md__iel2a {
  width: 20px;
  height: 15px;
}

.CountryFlag-module__lg__EBpwv {
  width: 24px;
  height: 18px;
}
`, "",{"version":3,"sources":["webpack://./../../packages/ui/src/components/utils/CountryFlag/CountryFlag.module.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,uCAAuC;EACvC,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd","sourcesContent":[".flag {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 15px;\n  border-radius: var(--mantine-radius-xs);\n  overflow: hidden;\n  flex-shrink: 0;\n}\n\n.sprite {\n  display: block;\n}\n\n.sm {\n  width: 18px;\n  height: 13px;\n}\n\n.md {\n  width: 20px;\n  height: 15px;\n}\n\n.lg {\n  width: 24px;\n  height: 18px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"flag": `CountryFlag-module__flag__LEnOR`,
	"sprite": `CountryFlag-module__sprite__pVzv_`,
	"sm": `CountryFlag-module__sm__IcjdD`,
	"md": `CountryFlag-module__md__iel2a`,
	"lg": `CountryFlag-module__lg__EBpwv`
};
module.exports = ___CSS_LOADER_EXPORT___;
